export const FETCH_BOOKINGS = '[BOOKINGS]FETCH_BOOKINGS';
export const FETCH_BOOKINGS_SUCCESS = '[BOOKINGS]FETCH_BOOKINGS_SUCCESS';
export const FETCH_BOOKINGS_FAILED = '[BOOKINGS]FETCH_BOOKINGS_FAILED';
